import { Link } from "react-router-dom";
import {
  Box,
  Button,
  Container,
  Grid,
  Typography,
  useMediaQuery,
} from "@mui/material";

import { ROUTES } from "@/utils/navigation";
import useResponsive from "@/hooks/useResponsive";

import FleetManagementShowcase from "./FleetManagementShowcase";
import { containerStyles } from "./styles";

const FleetManagement = () => {
  const isDesktop = useResponsive("up", "lg");
  const isMediumDesktop = useMediaQuery("(min-width: 1700px)");
  const isLargeDesktop = useMediaQuery("(min-width: 1900px)");

  return (
    <Box
      component="section"
      pt={{ xs: 0, md: 4, lg: 12.5 }}
      pb={{ xs: 5, md: 8, lg: 12.5 }}
      sx={{ overflowX: "hidden" }}
    >
      <Container sx={containerStyles}>
        <Grid
          container
          columnSpacing={{
            xs: 3,
            md: 3,
            lg: 6,
            xl: isLargeDesktop ? 21 : isMediumDesktop ? 16 : 10,
          }}
        >
          <Grid item xs={12} lg={6.5} xl={6.5}>
            <Box
              height="100%"
              display="flex"
              flexDirection="column"
              justifyContent="center"
            >
              <Typography
                color="text.primary"
                variant="h1"
                mb={{ xs: 2, md: 3 }}
              >
                Experience Next Generation Fleet Efficiency
              </Typography>
              <Typography
                variant="subtitle1"
                component="p"
                color="text.secondary"
                mb={{ xs: 4, md: 6, lg: 8.5 }}
              >
                We understand the critical role of making well-informed decisions when selecting the best 
                GPS tracking solution for your fleet. That's why we're thrilled to offer you a unique 
                opportunity to test our advanced devices—absolutely free! 
              </Typography>

              <Button
                variant="contained"
                component={Link}
                to={`${ROUTES.fleetInquiryForm}`}
                sx={{ width: { xs: "100%", sm: 222 } }}
              >
                Get Started Today
              </Button>
            </Box>
          </Grid>

          {isDesktop && (
            <Grid item xs={12} lg={5.5} xl={5.5}>
              <Box
                height="100%"
                display="flex"
                flexDirection="column"
                justifyContent="center"
                position="relative"
              >
                <FleetManagementShowcase />
              </Box>
            </Grid>
          )}
        </Grid>
      </Container>
    </Box>
  );
};

export default FleetManagement;
